<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'filter-wrapper',

  props: {
    activeFilter: Object,
    formFilter: Object
  },

  watch: {
    formFilter: {
      deep: true,

      async handler() {
        await this.editFormQuery()
      }
    },

    activeFilter: {
      deep: true,

      async handler() {
        await this.editActiveQuery()
      }
    }
  },

  mounted() {
    this.initActive()
    this.initForm()
  },

  methods: {
    initActive() {
      for (let key in this.activeFilter) {
        if (this.$route.query[`${key}_active`]) {
          this.activeFilter[key] = (this.$route.query[`${key}_active`] === 'true')
        }
      }
    },

    initForm() {
      for (let key in this.formFilter) {
        if (this.$route.query[`${key}_form`]) {
          this.formFilter[key] = this.$route.query[`${key}_form`]

        }
      }
    },

    async editActiveQuery() {
      let query = Object.assign({}, this.$route.query)
      for (let key in this.activeFilter) {
        if (String(this.activeFilter[key]) !== query[`${key}_active`]) {
          query[`${key}_active`] = this.activeFilter[key]
          await this.$router.replace({ query: query })
        }
      }
    },

    async editFormQuery() {
      let query = Object.assign({}, this.$route.query)
      for (let key in this.formFilter) {
        if (this.formFilter[key] !== query[`${key}_form`]) {
          query[`${key}_form`] = this.formFilter[key]
          await this.$router.replace({ query: query })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>